import React, { useState } from 'react';
import {
  Container,
  Header,
  FormField,
  RadioGroup,
  SpaceBetween,
  Button,
  Box,
  Badge
} from '@awsui/components-react';
import competitiveResearchWebSocketService from '../../services/CompetitiveResearchWebSocketService';

export function FileClassificationPanel({ classifications, jobId, onConfirm }) {
  const [userClassifications, setUserClassifications] = useState(() => {
    const initial = {};
    classifications.forEach(file => {
      initial[file.doc_id] = file.suggested_class;
    });
    return initial;
  });

  const handleClassificationChange = (docId, value) => {
    setUserClassifications(prev => ({ ...prev, [docId]: value }));
  };

  const handleConfirm = () => {
    competitiveResearchWebSocketService.sendMessage({
      action: 'confirm_file_classification',
      jobId: jobId,
      classifications: userClassifications
    });
    
    if (onConfirm) {
      onConfirm(userClassifications);
    }
  };

  const getConfidenceBadge = (confidence) => {
    const colorMap = { high: 'green', medium: 'blue', low: 'grey' };
    return <Badge color={colorMap[confidence] || 'grey'}>{confidence}</Badge>;
  };

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Review and confirm how each uploaded document should be used in research"
        >
          Classify Uploaded Documents
        </Header>
      }
    >
      <SpaceBetween size="l">
        {classifications.map(file => (
          <FormField
            key={file.doc_id}
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{file.filename}</Box>
                {getConfidenceBadge(file.confidence)}
              </SpaceBetween>
            }
            description={file.reasoning}
          >
            <RadioGroup
              value={userClassifications[file.doc_id]}
              onChange={({ detail }) => handleClassificationChange(file.doc_id, detail.value)}
              items={[
                {
                  value: 'ground_truth',
                  label: 'Ground Truth',
                  description: 'AWS official docs, specs, approved messaging (treat as authoritative)'
                },
                {
                  value: 'research_notes',
                  label: 'Research Notes',
                  description: 'Additional context, internal notes, background information'
                },
                {
                  value: 'third_party',
                  label: 'Third Party',
                  description: 'Competitor whitepapers, analyst reports (may be biased)'
                }
              ]}
            />
          </FormField>
        ))}
        
        <Box textAlign="right">
          <Button variant="primary" onClick={handleConfirm}>
            Confirm Classifications & Continue
          </Button>
        </Box>
      </SpaceBetween>
    </Container>
  );
}
